module.exports = __webpack_public_path__ + "img/c4.8ea09073.png";